import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@domain-group/fe-blueprint-ui/select';
import { ListingType } from '@domain-group/fe-allhomes-library';
import sortOptions, { DEFAULT_SORT } from './sort-options';
import * as styles from './allhomes-search-sorting.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesSearchSorting = props => ___EmotionJSX("div", {
  css: styles.container
}, ___EmotionJSX("div", {
  css: styles.label
}, "Sort by:"), ___EmotionJSX("div", {
  css: styles.selectContainer
}, ___EmotionJSX(Select, {
  css: styles.select,
  label: "search-sorting",
  options: sortOptions(props.listingType),
  onChange: select => props.onSelect(select.value),
  defaultValue: props.value,
  labelHidden: true,
  dropdownMaxHeight: 500
})));
AllhomesSearchSorting.propTypes = {
  listingType: PropTypes.string,
  value: PropTypes.string,
  onSelect: PropTypes.func
};
AllhomesSearchSorting.defaultProps = {
  listingType: ListingType.SALES_RESIDENTIAL.name,
  value: DEFAULT_SORT,
  onSelect: () => {}
};
export default AllhomesSearchSorting;